import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AccountantExpenseAdditionArea from '../../../components/addExpense'
import './style.scss'
const AddAccountantExpensePage = () => {

    return (
        <Fragment>
            
           <AccountantExpenseAdditionArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AddAccountantExpensePage
/* AddAccountantExpensePage */